module.exports = __webpack_public_path__ + "img/Folded_Paper_Werk_WUR_image_5.669e833b.png";